/**
 * Date helpers shared across client/server.
 * Keeps dependencies minimal and avoids Firebase-specific types.
 */
import moment from 'moment';

export function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    // Date-only fields describe a local calendar day, not midnight UTC.
    const calendar = value.trim().match(/^(\d{4})-?(\d{2})-?(\d{2})$/);
    if (calendar) {
      const [, year, month, day] = calendar.map(Number);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
        ? date : null;
    }
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  if (typeof value.toDate === 'function') {
    return value.toDate();
  }
  if (typeof value._seconds === 'number') {
    const millis = value._seconds * 1000 + Math.floor((value._nanoseconds || 0) / 1e6);
    return new Date(millis);
  }
  return null;
}

export function toMoment(value) {
  const date = toDate(value);
  if (!date) return null;
  return moment(date);
}

export function toTimestamp(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') {
    return value;
  }
  return toDate(value);
}
